import React from "react";
import UiTopNavProfile from "./UiTopNavProfile";
import TopNavBar from "./TopNavBar";
import UiHeaderWr from "./UiHeaderWr";
import ProfileImg from "../../../../styles/img/profile-img.jpg";
import { UiSingleContainer } from "../grid-container/GridContainer";

export default function TopHeader(props) {
    return (
        <>
            <UiHeaderWr>
                <UiSingleContainer fluid="fluid">
                    <TopNavBar />
                    <UiTopNavProfile
                        profileImg={ProfileImg}
                        name="Nick"
                        points="3.3k"
                    />
                </UiSingleContainer>
            </UiHeaderWr>
        </>
    );
}
